import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiAttachmentsListComponent } from './fi-attachments-list.component';
import { FiAttachmentsListItemComponent } from './fi-attachment-list-item/fi-attachments-list-item.component';
import { FiMediaBankFileReferencePreviewModule } from '@fi-shared/fi-media-bank-file-reference-preview/fi-media-bank-file-reference-preview.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FiVimeoModule } from '@fi-shared/media-bank/fi-vimeo/fi-vimeo.module';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        FiMediaBankFileReferencePreviewModule,
        FiVimeoModule,
        InfoIconModule,
        FiAppTextSharedModule,
    ],
    declarations: [FiAttachmentsListComponent, FiAttachmentsListItemComponent],
    exports: [FiAttachmentsListComponent, FiAttachmentsListItemComponent],
})
export class FiAttachmentsModule {}
